'use client';

import { useParams } from 'next/navigation';
import StampLogo from '@/components/ui/logo/StampLogo';
import Header from '@/components/ui/header/Header';
import styles from '../notFound.module.css';
import '../globals.css';
import { useEffect, useState } from 'react';
import initTranslations from '@/lib/i18n/i18n';
import type { TFunction } from 'i18next';
import type { Locales } from '@/types/i18n';

export default function NotFound() {
  const params = useParams();
  const locale = (params.locale as Locales) || 'en';
  const [t, setT] = useState<TFunction | null>(null);

  useEffect(() => {
    const loadTranslations = async () => {
      const { t } = await initTranslations(locale, ['translation']);
      setT(() => t);
    };

    loadTranslations();
  }, [locale]);

  if (!t) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Header />
      <main className={`pageLayout ${styles.main}`}>
        <StampLogo className={styles.logo} />
        <h1>{t('landing.title', 'Real TaxFree for Global travelers')}</h1>
        <h2>
          <span>{t('notFound.title', 'NOT FOUND')}</span>
        </h2>
        <p>{t('notFound.message', "You just hit a route that doesn't exist... the sadness.")}</p>
        <button
          className="primary"
          onClick={() => {
            window.location.href = `/${locale}/merchants`;
          }}
        >
          {t('notFound.homeButton', 'Take me home')}
        </button>
      </main>
    </>
  );
}
